import 'pickadate/lib/picker.js';
import 'pickadate/lib/picker.date.js';

import GG, {
	ggAmountControl,
} from 'ggcore';

GG.use(
	ggAmountControl
);

$(function () {
	if ($('.booking-small').length) {

		$('.booking-small .btn').click(function () {
			$(this).closest('.booking-small').find('.loading').fadeIn();
			return true;
		});

		if ($('html').attr('lang') === 'ru') {
			$.extend($.fn.pickadate.defaults, {
				monthsFull: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'],
				monthsShort: ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
				weekdaysFull: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
				weekdaysShort: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
				today: 'сегодня',
				clear: 'удалить',
				close: 'закрыть',
				firstDay: 1,
				format: 'ddd, dd mmm yyyy',
				formatSubmit: 'yyyy/mm/dd'
			});
		}

		var pickerDefaults = {
			format: 'ddd, dd mmm yyyy',
			formatSubmit: 'dd.mm.yyyy',
			/*monthsFull: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
			monthsShort: ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
			weekdaysFull: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
			weekdaysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
			firstDay: ['Понедельник'],*/
			today: false,
			clear: false,
			close: false,
			//min: true,
			hiddenName: true,
			editable: false
		};
		var $inputFromElement = $('.booking__entry_date .date_from');
		var $inputToElement = $('.booking__entry_date .date_to');
		var fromPickerOptions = $.extend({
			min: new Date($inputFromElement.data('min'))
		}, pickerDefaults);

		var toPicketOptions = $.extend({
			min: new Date($inputToElement.data('min'))
		}, pickerDefaults);

		$inputFromElement.pickadate(fromPickerOptions);
		var from_picker = $inputFromElement.pickadate('picker');

		$inputToElement.pickadate(toPicketOptions);
		var to_picker = $inputToElement.pickadate('picker');


		if (from_picker.get('value')) {
			to_picker.set('min', from_picker.get('select'))
		}
		/*if ( to_picker.get('value') ) {
			from_picker.set('max', to_picker.get('select'))
		}*/

		from_picker.on('set', function (event) {
			if (event.select) {
				//console.log();
				if (from_picker.get('select').obj >= to_picker.get('select').obj) {
					var dt = new Date(from_picker.get('select').obj);
					to_picker.set('select', dt.setDate(dt.getDate() + 1));
					console.log('set value');
				}


				//console.log(to_picker.get('select'));
				//console.log(from_picker.get('select') > to_picker.get('select'));
				//console.log(from_picker.get('select'));
				to_picker.set('min', from_picker.get('select'))
			} else if ('clear' in event) {
				to_picker.set('min', false)
			}
		});
		/*
			to_picker.on('set', function(event) {
				if ( event.select ) {
					from_picker.set('max', to_picker.get('select'))
				}
				else if ( 'clear' in event ) {
					from_picker.set('max', false)
				}
			});*/

		$('.booking__entry_guests > a').click(function (e) {
			e.preventDefault();
			$(this).next('.guests__dropdown').toggle();
		});

		$('body').on('click', function () {
			$('.booking__entry_guests .guests__dropdown').hide();
		});

		$('.booking__entry_date').on('click', function () {
			$('.booking__entry_guests .guests__dropdown').hide();
		});

		$('.booking__entry_guests > a').click(function (e) {
			e.stopPropagation();
		});

		$('.booking__entry_guests').on('click', function (e) {
			e.stopPropagation();

		});

		$('.booking__entry_guests').on('click', '.guests__add', function (e) {
			e.preventDefault();

			var $parent = $(this).closest('.block').parent();

			var $guestsTpl = $parent.find('.guests__tpl').clone();
			var $amountGrowups = $guestsTpl.find('.entry__amount_growups');
			var $amountKids = $guestsTpl.find('.entry__amount_kids');

			$guestsTpl.appendTo($parent.find('.guests__list')).removeClass('guests__tpl').addClass('guests__entry');

			setIndex();
			toggleAddLnk();

			$amountGrowups.amountControl({
				wrapper: $amountKids,
				child: '.amount',
				control: '.amount__container .amount__control'
			});

			$amountKids.amountControl({
				wrapper: $amountKids,
				child: '.amount',
				control: '.amount__container .amount__control'
			});
		});

		$('.booking__entry_guests').on('click', '.guests__entry .entry__remove', function (e) {
			e.preventDefault();
			$(this).closest('.guests__entry').remove();
			setIndex();
			toggleAddLnk();
		});

		function setIndex() {
			$('.guests__list .guests__entry .entry__number span').html('');

			$('.guests__list .guests__entry').each(function (i) {
				var $this = $(this);
				$this.find('.entry__number span').html(i + 1);
				$this.find('.entry__amount_growups input').attr('name', 'room[' + i + '][adults]');
				$this.find('.entry__amount_kids input').attr('name', 'room[' + i + '][child]');
			});
		}

		function toggleAddLnk() {
			if ($('.guests__entry').length > 5) {
				$('.guests__add').hide();
			} else {
				$('.guests__add').show();
			}
		}

	}
});
